import React, {useState} from "react";
import authService from "../../services/AuthService";
import LoginTemplate from "./LoginTemplate";
import {useNavigate} from "react-router-dom";

const Login = () => {

    const navigate = useNavigate()
    const [formValues, setFormValues] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [waitingForServer, setWaitingForServer] = useState(false)

    const onChange = (event) => {
        const {name, value} = event.target;
        setFormValues((prevState) => ({...prevState, [name]: value}));
    };

    const login = (e) => {
        e.preventDefault();
        setWaitingForServer(true)
        setErrorMessage('');
        authService.login(formValues)
            .then(response => {
                localStorage.setItem("user", JSON.stringify(response));
                navigate(response.role === "ROLE_GUEST" ? "/dashboard/project-tasks/projects" : "/dashboard/task-logs")
            })
            .catch(error => setErrorMessage(error.message))
            .finally(() => setWaitingForServer(false));
    };

    return <LoginTemplate
        {...{...formValues, onChange, login, waitingForServer, errorMessage}}
    />;
};

export default Login;
